package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.domain.catalog.BibleCatalog
import com.eladfinish.bible.contest.screens.mikud.model.BookState
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

class BuildBooksListUseCase {

    operator fun invoke(full: Boolean = true): ImmutableList<BookState> {
        return BibleCatalog.books.mapIndexed { index, bookData ->
            BookState(
                index = index,
                name = bookData.hebrew,
                english = bookData.trans,
                chapters = List(bookData.numberOfChapters) { full }.toImmutableList(),
            )
        }.toImmutableList()
    }
}
